export default IconRouteSquare2 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-route-square-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M14 5a2 2 0 0 0 -2 2v10a2 2 0 0 1 -2 2" />
  <path d="M3 17h4v4h-4z" />
  <path d="M17 3h4v4h-4z" />
</svg>`;